module.exports = __webpack_public_path__ + "static/media/datazip-landing-image.0f9aa6c1.svg";